import $ from 'jquery';

$(document).ready(function() {
  const $tabs = $('.e-tabs');

  //
  $tabs.each(function() {
    const $thisTabs = $(this);

    $thisTabs.find('.tabs a').on('click', function(event) {
      event.preventDefault();

      const $thisLink = $(this);
      const $li = $thisLink.closest('li');
      const dataTab = $thisLink.attr('data-tab');

      //
      $thisTabs.find('.tabs .active').removeClass('active');
      $thisTabs.find('.tab-content.active').removeClass('active');

      //
      $li.addClass('active');
      $thisTabs.find(`.${dataTab}`).addClass('active');

      //
      $thisTabs.trigger('tabs:change', [dataTab])
    });
  });

});



// WEBPACK FOOTER //
// ./app/ui/elements/tabs/index.js